import 'angular:locale/data:fr-ca';
import 'angular:locale/data:en-ca';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
